module.exports = __webpack_public_path__ + "static/tools-7c88e2abbb805437d41aa73706d919be.svg";